import React from 'react';
import { View } from 'react-native';
import Svg, { ClipPath, G, Defs, Path, Rect } from 'react-native-svg';
import { IconProps } from '@/components/NeolexonIcon/Icons/types';
import colors from '@/config/colors';
import { IS_WEB } from '@/utils/platform';

export const Book = ({
  color = colors.primary,
  isInverted = true,
  size = 24,
  style,
  fillColor,
  ...props
}: IconProps & { isInverted?: boolean }) => {
  if (IS_WEB) {
    return (
      <View {...props}>
        <svg
          width={size}
          height={size}
          viewBox="0 0 20 20"
          fill={isInverted ? color : 'white'}
          style={style as React.CSSProperties}
        >
          <g clipPath="url(#clip0_3149_13423)">
            <path
              d="M4.5499 16.8941L2.74597 5.0305C2.66623 4.50609 2.79808 3.97149 3.1125 3.54429C3.42693 3.1171 3.89818 2.83231 4.42258 2.75257L14.3089 1.24929C14.5187 1.21739 14.7326 1.27013 14.9034 1.3959C15.0743 1.52167 15.1882 1.71017 15.2201 1.91994L17.3848 16.1563C17.4167 16.3661 17.364 16.5799 17.2382 16.7508C17.1125 16.9217 16.924 17.0356 16.7142 17.0675L6.82783 18.5707C6.30342 18.6505 5.76882 18.5186 5.34163 18.2042C4.91443 17.8898 4.62964 17.4185 4.5499 16.8941ZM4.5499 16.8941C4.47016 16.3697 4.60201 15.8351 4.91644 15.4079C5.23086 14.9807 5.70211 14.6959 6.22652 14.6162L16.9038 12.9927M6.69131 9.69035L13.0186 8.72826M6.21026 6.52672L10.9557 5.80515"
              stroke={isInverted ? 'white' : color}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_3149_13423">
              <rect
                width={size}
                height={size}
                fill={isInverted ? 'white' : color}
              />
            </clipPath>
          </defs>
        </svg>
      </View>
    );
  }

  return (
    <Svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill={isInverted ? color : 'white'}
      style={style}
      {...props}
    >
      <G clipPath="url(#clip0_3149_13423)">
        <Path
          d="M4.5499 16.8941L2.74597 5.0305C2.66623 4.50609 2.79808 3.97149 3.1125 3.54429C3.42693 3.1171 3.89818 2.83231 4.42258 2.75257L14.3089 1.24929C14.5187 1.21739 14.7326 1.27013 14.9034 1.3959C15.0743 1.52167 15.1882 1.71017 15.2201 1.91994L17.3848 16.1563C17.4167 16.3661 17.364 16.5799 17.2382 16.7508C17.1125 16.9217 16.924 17.0356 16.7142 17.0675L6.82783 18.5707C6.30342 18.6505 5.76882 18.5186 5.34163 18.2042C4.91443 17.8898 4.62964 17.4185 4.5499 16.8941ZM4.5499 16.8941C4.47016 16.3697 4.60201 15.8351 4.91644 15.4079C5.23086 14.9807 5.70211 14.6959 6.22652 14.6162L16.9038 12.9927M6.69131 9.69035L13.0186 8.72826M6.21026 6.52672L10.9557 5.80515"
          stroke={isInverted ? 'white' : color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </G>
      <Defs>
        <ClipPath id="clip0_3149_13423">
          <Rect
            width={size}
            height={size}
            fill={isInverted ? 'white' : color}
          />
        </ClipPath>
      </Defs>
    </Svg>
  );
};
